import * as types from "./types";

const initialState = {
  selectMode: false,
  selectAll: false,
  selectedItems: {},
  selectedItemOrder: [],
};

export const currentSelectedItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SELECT_MODE: {
      return { ...state, ...action.payload, changed: new Date().getTime() };
    }
    case types.SET_SELECT_ALL: {
      return { ...state, ...action.payload, changed: new Date().getTime() };
    }
    case types.ADD_CURRENT_SELECTED_ITEMS: {
      const { items = {} } = action.payload;
      const newSelectedItems = { ...state.selectedItems };
      const newSelectedItemOrder = [...state.selectedItemOrder];

      for (const [id, asset] of Object.entries(items)) {
        if (!newSelectedItems[id]) {
          newSelectedItemOrder.push(id);
        }
        newSelectedItems[id] = asset;
      }

      return {
        ...state,
        selectedItems: newSelectedItems,
        selectedItemOrder: newSelectedItemOrder,
        changed: Date.now(),
      };
    }
    case types.REMOVE_CURRENT_SELECTED_ITEMS: {
      const { items = [] } = action.payload;
      const selectedItems = { ...state.selectedItems };

      const itemIdsToRemove = items.map(String);

      const selectedItemOrder = state.selectedItemOrder.filter((id) => !itemIdsToRemove.includes(id));
      itemIdsToRemove.forEach((id) => delete selectedItems[id]);

      return {
        ...state,
        selectedItems,
        selectedItemOrder,
        changed: Date.now(),
      };
    }
    case types.RESET_CURRENT_SELECTED_ITEMS: {
      return {
        ...state,
        selectedItems: {},
        selectedItemOrder: [],
        changed: Date.now(),
      };
    }
    default:
      return state;
  }
};
